import type { CanDeactivateFn } from '@angular/router';
import type { ReviewAndPay } from './review-and-pay';

/**
 * Prompts before leaving Review & Pay (browser back, stepper, or other router navigation).
 */
export const reviewAndPayLeaveGuard: CanDeactivateFn<ReviewAndPay> = (
  component,
  _currentRoute,
  _currentState,
  nextState,
) => {
  const destinationUrl = nextState?.url;
  if (!destinationUrl) {
    return true;
  }

  return component.confirmLeave(destinationUrl);
};
